import React from "react";
import { Search } from "lucide-react";

export default function SearchBar({ value, onChange, placeholder, testId }) {
  return (
    <div className="relative w-full" data-testid={testId || "search-bar"}>
      <Search
        size={16}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-ink-400 pointer-events-none"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={`${testId || "search-bar"}-input`}
        className="w-full bg-bone border border-ink-200 pl-11 pr-4 py-2.5 text-sm font-body text-ink-900 transition-colors focus:outline-none focus:ring-1 focus:ring-ink-900/20 focus:border-ink-900 placeholder:text-ink-400 placeholder:text-[13px]"
      />
    </div>
  );
}
